import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import MoreButton from '@/components/XPower/elements/MoreButton';
import { QuietIcon } from '@/components/XPower/svg';
import ProgressGroup from '@/components/XPower/elements/ProgressGroup';
import Video from '@/components/XPower/elements/Video';
import getLocal from '@/app/utils/getLocal';

const XCooling: FC = () => {
    const { t } = useLang('xcode.xcooling');
    const { locale } = getLocal();

    let mediaList = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701473342/2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701395724/X-quiet-1.jpg',
            text: t.rich('media.media_text1', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701487555/8.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701825770/X-quiet2.jpg',
            text: t.rich('media.media_text2', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701501894/9.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701444396/X-quiet3.jpg',
            text: t.rich('media.media_text3', {
                line: (text: string) => <span>{text}</span>,
            }),
        },
    ];
    if (locale === 'uk') {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729555954/quiet1_uk.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729572457/quiet1_ukm.jpg',
                text: t.rich('media.media_text1', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729585581/quiet2_uk.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729601081/quiet2_ukm.jpg',
                text: t.rich('media.media_text2', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729614185/quiet3_uk.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729627340/quiet3_ukm.jpg',
                text: t.rich('media.media_text3', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
        ];
    }

    if (['it', 'de', 'es', 'eu', 'fr'].includes(locale)) {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729467544/quiet1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729483120/quiet1_m.jpg',
                text: t.rich('media.media_text1', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729498119/quiet2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729511638/quiet2_m.jpg',
                text: t.rich('media.media_text2', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724729526598/quiet3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724729541283/quiet3_m.jpg',
                text: t.rich('media.media_text3', {
                    line: (text: string) => <span>{text}</span>,
                }),
            },
        ];
    }

    const progressList = [
        {
            text: t('progress.progress_text1'),
            number: 70,
            unit: t('progress.progress_unit'),
        },
        {
            text: t('progress.progress_text2'),
            number: 60,
            unit: t('progress.progress_unit'),
        },
        {
            text: t('progress.progress_text3'),
            number: 30,
            unit: t('progress.progress_unit'),
        },
    ];

    return (
        <div className={styled.XCooling}>
            <Header icon={<QuietIcon />} desc={t('title')} subtitle={t('subtitle')} />
            <div className="big-central media_box">
                <Video src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718701359974/X-quiet.mp4" />
            </div>
            <div className="middle-central">
                <div className="text_box">
                    <div className="left font-desc">
                        {t('text.left')}
                        <p className="tips">{t('text.tips')}</p>
                    </div>
                    <div className="right font-desc">
                        <div className="img">
                            <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718696608800/Rectangle%2051016.png" alt={t('title')} />
                        </div>
                    </div>
                </div>
                <ProgressGroup title={t('progress.progress_title')} list={progressList} />
            </div>
            <MoreButton text={t('btn_more')} mediaList={mediaList} />
        </div>
    );
};

export default XCooling;
